export const SENSITIVE_FIELDS = [
  'password',
  'accessToken',
  'refreshToken',
  'token',
  'ssn',
  'ssnLast4',
  'ein',
  'itin',
  'tin',
  'fein',
  'taxId',
  'accountNumber',
  'bankAccountNumber',
  'routingNumber',
  'bankRoutingNumber',
  'cardNumber',
  'cvv',
  'nameOnCard',
  'expirationDate',
  'driverLicenseNumber',
  'dob',
  'dateOfBirth',
  'streetAddress',
  'address',
  'beneficiaryFirstName',
  'beneficiaryLastName',
  'beneficiaryDob',
  'beneficiaryAddress',
  'vin',
  'vehicleVIN',
  'policyNumber',
  'policyDocument',
  'dotNumber',
  'usdotNumber',
  'mcNumber',
  'bgcFile',
  'mvrFile',
]

export function sanitizeObject<T>(obj: T): T {
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => sanitizeObject(item)) as T
  }

  const result: Record<string, unknown> = {}

  for (const [key, value] of Object.entries(obj)) {
    if (SENSITIVE_FIELDS.some((field) => key.toLowerCase().includes(field.toLowerCase()))) {
      result[key] = '[REDACTED]'
    } else if (Array.isArray(value)) {
      result[key] = value.map((item) => sanitizeObject(item))
    } else if (typeof value === 'object' && value !== null) {
      result[key] = sanitizeObject(value)
    } else {
      result[key] = value
    }
  }

  return result as T
}
